// Note: These styles are all global and not scoped because
// some elements are created dynamically by the pannellum library

@import "../../../node_modules/pannellum/build/pannellum";

stzh-panorama {
  @include host;
}

.stzh-panorama {
  &__hotspot {
    width: 40px;
    height: 40px;
  }

  stzh-button#{&}__hotspot-button,
  stzh-button#{&}__control {
    --box-shadow: #{$boxShadowPopover};
    --border-width: 0px;
  }

  stzh-button#{&}__hotspot-button {
    &.is-info {
      --cursor: default;
    }
  }

  &__hotspot-tooltip {
    white-space: nowrap;
  }

  &__sceneselector {
    bottom: space('xsmall');
    left: space('xsmall');
    z-index: 2;
    position: absolute;
    display: flex;
    gap: space('xsmall');

    @media print {
      display: none;
    }

    @include mq($from: medium) {
      bottom: space('large');
      left: space('large');
    }

    &-dropdown {
      --color: #{$colorGrey80};
      --hover-color: #{$colorGrey90};
      --icon-angle-color: #{$colorGrey80};
      --hover-icon-angle-color: #{$colorGrey80};
      --border-color: #{$colorWhite};
      --hover-border-color: #{$colorWhite};
      --focus-border-color: #{$colorWhite};
      --focus-background-color: #{$colorWhite};

      * {
        box-sizing: border-box; // necessary override of global plnm box-sizing which is causing size issues.
      }
    }
  }

  &__copyright {
    background-color: var(--stzh-color-black50op);
    color: var(--stzh-color-white80op);
    padding-left: space('medium');
    padding-right: space('medium');
    padding-top: space('xsmall');
    padding-bottom: space('xsmall');
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__controls {
    bottom: space('xsmall');
    right: space('xsmall');
    z-index: 2;
    pointer-events: none;
    position: absolute;
    display: flex;
    flex-direction: row;
    gap: space('xxsmall');

    @media print {
      display: none;
    }

    @include mq($from: medium) {
      bottom: space('large');
      right: space('large');
    }
  }

  &__control {
    pointer-events: all;

    &--show-medium {
      visibility: hidden;

      @include mq($from: medium) {
        visibility: visible;
      }
    }
  }
}
